/*
===============================================================================================================
                                 Copyright 2022-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import moment from 'moment';

dayjs.extend(utc);
/**
 * This helper is used to help with dealing with dates within the application.
 */

export const getStartOfDayUTC = (date) => {
  let dateObj = date;
  if (moment.isMoment(date)) {
    dateObj = moment(date).toDate();
  }
  return dayjs(dateObj).utc().startOf('day').toISOString();
};

export const getEndOfDayUTC = (date) => {
  let dateObj = date;
  if (moment.isMoment(date)) {
    dateObj = moment(date).toDate();
  }
  return dayjs(dateObj).utc().endOf('day').toISOString();
};

export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const formatDateForBackend = (date) => {
  if (!date) return null;
  let dateObj = date;
  if (moment.isMoment(date)) {
    dateObj = moment(date).toDate();
  }
  return dayjs(dateObj).format('YYYY-MM-DD');
};
